export enum ItemType {
  SESSION = "session",
  BOOKING = "booking",
  REQUEST = "request",
  INVITE = "invite",
  PROJECT = "project",
  HABILITATION = "habilitation",
  USER = "user",
}

export enum VatEnum {
  TTC = "TTC",
  HT = "HT",
}

export enum MicroserviceEnum {
  ORDERS = "orders",
  ORDERS_REPORTING = "orders_reporting",
}

export enum EnvironmentEnum {
  LOCAL = "LOCAL",
  STAGING = "STAGING",
  PROD = "PROD",
}

export enum GridStyle {
  MAIN = "main",
  SECONDARY = "secondary",
}

export enum SimbelEmail {
  CLAIRE = "claire@simbel.fr",
  /** Orders' system account: it signs what orders writes outside a user request (jobs, syncs). */
  API = "api@simbel.fr",
}

/** HTTP statuses the front branches on: every SDK rejection carries one on `status`, raw `useFetchApi` errors always. */
export enum HttpStatusEnum {
  FOUND = 302,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  GONE = 410,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
}

/** `PromiseSettledResult.status`, so `Promise.allSettled` branches read as enums like every other status. */
export enum PromiseSettledStatusEnum {
  FULFILLED = "fulfilled",
  REJECTED = "rejected",
}

/** Authentication uses bearer tokens rather than browser cookies. */
export enum FetchCredentialsEnum {
  OMIT = "omit",
}

/** `RequestInit.redirect`: `MANUAL` hands a redirect back instead of following it. */
export enum FetchRedirectEnum {
  MANUAL = "manual",
  ERROR = "error",
}

/** `Response.type`: a redirect a `MANUAL` fetch hands back reads as `OPAQUE_REDIRECT`. */
export enum FetchResponseTypeEnum {
  OPAQUE_REDIRECT = "opaqueredirect",
}

export enum AsyncJobStatusEnum {
  TO_PROCESS = "to_process",
  ON_GOING = "on_going",
  COMPLETE = "complete",
  ERROR = "error",
}

export const ASYNC_JOB_STATUS_LABELS: Record<AsyncJobStatusEnum, string> = {
  [AsyncJobStatusEnum.TO_PROCESS]: "En file d'attente",
  [AsyncJobStatusEnum.ON_GOING]: "En cours",
  [AsyncJobStatusEnum.COMPLETE]: "Terminé",
  [AsyncJobStatusEnum.ERROR]: "Échec",
};
